<div class="tab-content active">
    <div class="grid" *ngIf="group.name !== 'finales' && group.name !== 'posiciones'">
        <div class="card">
            <div class="card-header">
                <h3>Grupo {{group.name}}</h3>
                <div class="group-actions" *ngIf="esAdmin$ | async">
                    <a (click)="createPlayer()">Crear jugador</a>
                    <a (click)="addPlayer()">Agregar jugador a grupo</a>
                    <a (click)="recalculate()">Calcular grupo</a>
                </div>
            </div>
            <div class="player-list" *ngIf="playersGroup">
                <div class="player" *ngFor="let p of playersGroup">
                    <div class="player-avatar">{{p.player?.playerLabel}}</div>
                    <div class="player-name">{{p.player?.playerName}}</div>
                    <div class="player-order">{{p.order}}</div>
                    <div class="games-played">
                        <div class="result-title" title="Partidos jugados">PJ</div>
                        <div class="value">{{p.matchesPlayed ?? 0}}</div>
                    </div>
                    <div class="games-result">
                        <div class="result-title" title="Partidos ganados - perdidos">PG - PP</div>
                        <div class="value">{{p.matchesWon ?? 0}} - {{p.matchesLost ?? 0}} <span class="dif">({{(p.matchesWon ?? 0) - (p.matchesLost ?? 0)}})</span></div>
                    </div>
                    <div class="set-result">
                        <div class="result-title" title="Games ganados - perdidos">GG - GP</div>
                        <div class="value">{{p.setsWon ?? 0}} - {{p.setsLost ?? 0}} <span class="dif">({{(p.setsWon ?? 0) - (p.setsLost ?? 0)}})</span></div>
                    </div>
                    <div class="points-result">
                        <div class="result-title" title="Puntos ganados - perdidos">Pt. (G-P)</div>
                        <div class="value">{{p.pointsWon ?? 0}} - {{p.pointsLost ?? 0}} <span class="dif">({{(p.pointsWon ?? 0) - (p.pointsLost ?? 0)}})</span></div>
                    </div>
                    <div class="player-actions" *ngIf="esAdmin$ | async">
                        <div style="color: #ff6b35; font-weight: 600;">{{p.player?.playerId}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-category-final-component [category]="category" *ngIf="group.name === 'finales'"></app-category-final-component>

    <app-category-classification-group [category]="category" *ngIf="group.name === 'posiciones'"></app-category-classification-group>

    <div class="matches-header" *ngIf="group.name !== 'posiciones'">
        <h3>Programación de Partidos: <strong>{{categoryType}} {{group.name}}</strong></h3>
        <div class="matches-actions" *ngIf="esAdmin$ | async">
            <a (click)="createMatch()">Crear partido</a>
            <a (click)="createMatches()">Crear partidos del grupo</a>
        </div>
    </div>

    <div class="matches-container">
        <div class="match-schedule" *ngFor="let matchByDay of matchesByDay">
            <!-- <h3 style="margin-bottom: 20px; color: #ff6b35;">{{ matchByDay.date | date:'EEEE d \'de\' MMMM' }}</h3> -->
            <div class="match-container" *ngFor="let match of matchByDay.matches">
                <div class="match">
                    <div class="match-time">{{match.date | date:'shortTime' }}</div>
                    <div class="match-players">
                        <span [ngClass]="{'winner': match.playerIdWinner === match.player1Id}">{{match.player1?.playerName}}</span>
                        <span class="vs">vs</span>
                        <span [ngClass]="{'winner': match.playerIdWinner === match.player2Id}">{{match.player2?.playerName}}</span>
                    </div>
                    <div class="match-court">Cancha {{match.court || '?'}}</div>
                    <div class="match-state">{{match.state}}</div>
                    <div class="match-score-container">
                        <ng-container *ngFor="let game of match.games">
                            <div class="match-score-container"  *ngIf="game.player1Points > 0 || game.player2Points > 0">
                                {{game.player1Points}} - {{game.player2Points}}
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="matches-actions" *ngIf="esAdmin$ | async">
                    <div>Código<strong>{{match.code}}</strong></div>
                    <a (click)="startMatch(match)">Iniciar Partido</a>
                    <a (click)="resetMatch(match)">Resetear Partido</a>
                    <a (click)="endMatch(match)">Finalizar Partido</a>
                    <a (click)="deleteMatch(match)">Eliminar Partido</a>
                </div>
            </div>
            
        </div>
    </div>
</div>